import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57ce1f10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-items" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "checkout-items-title" }, " Your order ", -1))
const _hoisted_3 = { class: "checkout-items-line" }
const _hoisted_4 = { class: "checkout-items-line-top" }
const _hoisted_5 = {
  key: 0,
  class: "checkout-items-line-bottom"
}
const _hoisted_6 = {
  key: 0,
  class: "checkout-items-line"
}
const _hoisted_7 = { class: "checkout-items-line-top" }
const _hoisted_8 = { class: "checkout-item-with-tooltip" }
const _hoisted_9 = {
  key: 0,
  class: "checkout-items-line-bottom"
}
const _hoisted_10 = { class: "checkout-items-line" }
const _hoisted_11 = { class: "checkout-items-line-top checkout-items-line-total" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_13 = {
  key: 0,
  class: "checkout-items-line-top checkout-items-line-total"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString(''), -1))
const _hoisted_15 = {
  key: 1,
  class: "checkout-items-line-bottom"
}

import { BigNumber } from '@ethersproject/bignumber';
import { formatEther } from '@ethersproject/units';
import { computed } from 'vue';
import { MANIFOLD_FEE_EXPLANATION } from '@/common/constants';
import Tooltip from '@/components/Tooltip.vue';
import { useClaimStore } from '@/store/claimStore';

interface CheckoutItemsProps {
  numberToMint: number;
  cost?: BigNumber;
  hasFees: boolean;
  price: BigNumber;
  priceInUsd: number;
  manifoldFee: BigNumber;
  manifoldFeeInUsd: number;
  total: BigNumber;
  totalInUsd: number;
  ercTwenty: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutItems',
  props: {
    numberToMint: null,
    cost: null,
    hasFees: { type: Boolean },
    price: null,
    priceInUsd: null,
    manifoldFee: null,
    manifoldFeeInUsd: null,
    total: null,
    totalInUsd: null,
    ercTwenty: null
  },
  setup(__props: any) {

const props = __props as {
  numberToMint: number;
  cost?: BigNumber;
  hasFees: boolean;
  price: BigNumber;
  priceInUsd: number;
  manifoldFee: BigNumber;
  manifoldFeeInUsd: number;
  total: BigNumber;
  totalInUsd: number;
  ercTwenty: string;
};

const store = useClaimStore();



const currencyString = computed(() => {
  return props.ercTwenty ? props.ercTwenty : store.networkId === 10 ? 'OETH' : 'ETH';
});

const priceString = computed(() => {
  return formatEther(props.cost || 0);
});

const priceSubtotalString = computed((): string => {
  if (isNaN(props.numberToMint)) return '';
  return formatEther(props.price);
});

const manifoldFeeSubtotalString = computed((): string => {
  if (isNaN(props.numberToMint)) return '';
  return formatEther(props.manifoldFee);
});

const totalString = computed((): string => {
  return formatEther(props.total);
});

const usdPriceSubtotalString = computed((): string => {
  return props.priceInUsd ? `${(props.priceInUsd).toFixed(2)}` : '';
});

const usdManifoldFeeSubtotalString = computed((): string => {
  return props.manifoldFeeInUsd ? `${(props.manifoldFeeInUsd).toFixed(2)}` : '';
});

const usdTotalString = computed((): string => {
  return props.totalInUsd ? `${(props.totalInUsd).toFixed(2)}` : '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_unref(priceString)) + " " + _toDisplayString(_unref(currencyString)) + " x " + _toDisplayString(__props.numberToMint), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(priceSubtotalString)) + " " + _toDisplayString(_unref(currencyString)), 1)
      ]),
      (!!_unref(usdPriceSubtotalString))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, "~$" + _toDisplayString(_unref(usdPriceSubtotalString)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.hasFees)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, "Manifold Fee x " + _toDisplayString(__props.numberToMint), 1),
              _createVNode(Tooltip, {
                header: "Manifold Fee",
                content: _unref(MANIFOLD_FEE_EXPLANATION)
              }, null, 8, ["content"])
            ]),
            _createElementVNode("span", null, _toDisplayString(_unref(manifoldFeeSubtotalString)) + " " + _toDisplayString(_unref(store).networkId === 10 ? 'OETH' : 'ETH'), 1)
          ]),
          (!!_unref(usdManifoldFeeSubtotalString))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", null, "~$" + _toDisplayString(_unref(usdManifoldFeeSubtotalString)), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(__props.ercTwenty ? _unref(manifoldFeeSubtotalString) : _unref(totalString)) + " " + _toDisplayString(_unref(store).networkId === 10 ? 'OETH' : 'ETH'), 1)
      ]),
      (__props.ercTwenty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_unref(priceSubtotalString)) + " " + _toDisplayString(_unref(currencyString)), 1)
          ]))
        : _createCommentVNode("", true),
      (!!_unref(usdTotalString))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("span", null, "~$" + _toDisplayString(_unref(usdTotalString)), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})